import styled from "styled-components";

import {
    DESKTOP_BREAKPOINT,
    MOBILE_BREAKPOINT,
    WIDE_BREAKPOINT,
} from "features/MenuEditor/styles";

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;

    @media (min-width: ${WIDE_BREAKPOINT}px) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    @media (max-width: ${DESKTOP_BREAKPOINT - 1}px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
    }
`;

export const LoadMoreAnchor = styled.div`
    height: 1px;
`;

export const LoadingMore = styled.p`
    margin: 16px 0 0;
    text-align: center;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.54);
`;
